import './Private.scss'
import React, { Component } from 'react'
import {
    Video,
    Status,
    sdk,
    getBioDataFromVideo
} from '@svort/component'
import axios from '../../utils/axios'
import {
    imageDataToBase64,
    delay
} from '../../utils/utils'
import { Translated } from '../../utils/translated'
import Timer from '../../components/Timer/Timer'

export class Private extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isStarted: false,
            isUserFound: false,
            isTimerStarted: false,

            isError: false,
            isLoading: false,
            status: null,
            onRetry: () => {
                this.setState({
                    isError: false,
                    isInit: true,
                    isLoading: true,
                    status: 'permission_request'
                });
            }
        }

        this.videoRef = React.createRef();
        this.baseRadius = Math.max(window.outerHeight, window.innerHeight) * 0.45 / 2;
        this.logoutTimer = null;
    }

    async componentDidMount() {
        this.checkSDKLoaded();
    }

    checkSDKLoaded = () => {
        this.setState({
            isLoading: true,
            isPureStatus: true,
            status: <Translated id="downloading_sdk" values={{ progress: 0 }} />
        }, async () => {
            const isLoaded = await sdk.isLoaded();
            if (isLoaded) {
                this.setState({
                    isInit: true,
                    isLoading: true,
                    isPureStatus: false,
                    status: 'permission_request'
                });
            }
            else sdk.setProgressListener((data) => {
                if (data.isLoaded) {
                    this.setState({
                        isInit: true,
                        isLoading: true,
                        isPureStatus: false,
                        status: 'permission_request'
                    });
                } else this.setState({
                    status: <Translated id="downloading_sdk" values={{ progress: (data.currentProgress * 100 / data.dataSize).toFixed(1) }} />
                })
            });
        });
    }

    onVideoCanPlay = () => {
        this.setState({
            isInit: false,
            isLoading: false,
            isStarted: true,
            status: 'prepare'
        }, () => {
            this.hiddenVerification();
        });
    }

    onVideoError = (error, message) => {
        console.log('video_error:', error, message);

        this.setState({
            isInit: false,
            isLoading: false,
            isError: true,
            status: error
        });
    }

    async hiddenVerification() {
        const { imageData, bioData } = await getBioDataFromVideo(this.videoRef.current);

        if (bioData) {
            const photo = await imageDataToBase64(imageData);
            const response = await axios.post('check_identity', { photo });
            const { status, probables } = response;

            if (status !== 'success' || !probables.some(x => x.login === this.props.login)) {
                this.setState({ isUserFound: false });
                this.startLogoutTimer();
            } else {
                clearTimeout(this.logoutTimer);
                this.logoutTimer = null;
                this.setState({
                    isUserFound: true,
                    isTimerStarted: false
                });
            }
        } else {
            this.setState({ isUserFound: false });
            this.startLogoutTimer();
        }

        await delay(100);
        if (this.props.isShow && this.state.isStarted && !this.state.isError && !this.state.isLoading)
            this.hiddenVerification();
    }

    startLogoutTimer = () => {
        if (this.logoutTimer)
            return;

        this.logoutTimer = setTimeout(() => {
            this.setState({
                isTimerStarted: true
            });
        }, 2000);
    }

    render() {
        return this.props.isShow ? (
            <div className='private'>

                <Video
                    isInit={this.state.isInit}
                    videoRef={this.videoRef}
                    baseRadius={this.baseRadius}

                    onVideoCanPlay={this.onVideoCanPlay}
                    onError={this.onVideoError} />

                {this.state.isStarted &&
                    <div className='content'>
                        <p><Translated id='app.private.welcome' />,&nbsp;{this.props.login}!</p>
                        <p><Translated id='app.private.title' /></p>
                        <p><Translated id='app.private.title-hint' /></p>

                        <Timer
                            isShow={this.state.isTimerStarted}
                            baseRadius={this.baseRadius}
                            onTimesUp={this.props.onLogout} />
                    </div>}

                <Status
                    isShow={this.state.isLoading || this.state.isError}
                    isLoading={this.state.isLoading}
                    isError={this.state.isError}
                    isPure={this.state.isPureStatus}
                    onRetry={this.state.onRetry}>
                    {this.state.status}
                </Status>
            </div>
        ) : null
    }
}

export default Private
